module.exports = __webpack_public_path__ + "img/热带雨林.3006fb34.jpg";